import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";
import dayjs from 'dayjs';

//  I N T E R F A C E S
export interface Details {
    entries: Entries[];
    employeeId: number;
    employee: string;
    date: number;   // milliseconds
    inUsePC: InUsePC;
}
export interface Entries {
    Alert: any;
    ApprovedBy: number;
    ApprovedByUserName: string;
    Category: string;
    CodeDescription: any;
    Comment: string;
    CreatedBy: number;
    CreatedDate: Date;
    DayOfWeek: string;
    DeletedBy: any;
    DeletedDate: any;
    DepartmentId: number;
    DisabledBy: number;
    DisabledDate: Date;
    EmployeeId: number;
    EmployeeName: string;
    EnteredFieldTimeCodeId: any;
    EntryDate: Date;
    Error: boolean;
    ErrorMessage: any;
    FieldTimeCodeId: number;
    IsApproved: boolean;
    IsDisputed: boolean;
    IsOutOfPC: boolean;
    IsReadOnly: boolean;
    LocatorComment: string;
    LunchHours: number;
    ModifiedBy: number;
    ModifyDate: Date;
    PayrollExportDate: any;
    ProfitCenterId: number;
    Quantity: number;
    SystemComment: any;
    TimeEntryId: number;
    Validation: Validation;
}
export interface Validation {
    IsValid: boolean;
    ValidationMessages: any[];
}
export interface ValidationMessages {

}
export interface InUsePC {
    value: number;
    label: string;
}

export interface Reference {
    departments: Department[];
    profitCenters: ProfitCenter[];
    states: State[];
}
export interface Department {
    DepartmentId: number;
    Description: string;
    DisplayName: string;
    ProfitCenterId: number;
}
export interface ProfitCenter {
    displayName: string;
    id: number;
    name: string;
    stateId: number;
}
export interface State {
    id: number;
    name: string;
}

export interface TimeAdminDetailsProps {
    details: Details;
    profitCenter: number | null;
    reference: Reference;
    profitCenterName: string | null;
}

//  A P I   C A L L S
export const getReferenceData = async (cancelTokenSource: any) => {
    if (cancelTokenSource.current?.token) {
        cancelTokenSource.current?.cancel();
    }
    cancelTokenSource.current = Axios.CancelToken.source();

    const response = await Axios.get(process.env.REACT_APP_API_URL + "/api/timeadmin/reference", { ...AxiosConfig.configValue('min'), cancelToken: cancelTokenSource.current?.token });
    console.log('reference data response: ', response);

    if (!response.data.Error.success) {
        return { success: false, response: response.data.Error.message };
    }
    
    const { states, profitCenters, departments } = response.data;
    const reference: Reference = { departments, profitCenters, states };
    return { success: true, response: reference };
}
export const getEmployeeTimeData = async (employeeId: number, profitCenterId: number, date: Date) => {
    const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/timeadmin/employeetimedata/${employeeId}/${profitCenterId}/${dayjs(date).valueOf()}/${dayjs(date).valueOf()}`, AxiosConfig.configValue("min"));
    console.log('employee time data response: ', response); 
    
    if (!response.data.Error.success) {
        return { success: false, response: response.data.Error.message }
    }
    
    const entries: Entries[] = [];
    response.data.timesheets.forEach((item: Entries) => {
        entries.push(item);
    });
    console.log('entries: ', entries);
    return { success: true, response: entries };
}

//  F U N C T I O N S
export const initializeTimeAdminEmployeeDetails = async (cancelTokenSource: any, employeeId: number, employeeName: string, profitCenterId: number, profitCenterName: string, date: Date) => {    
    const referenceResponse = await getReferenceData(cancelTokenSource);
    if (!referenceResponse.success) return { success: false, response: referenceResponse.response }    
    
    const timeDataResponse = await getEmployeeTimeData(employeeId, profitCenterId, date);
    if (!timeDataResponse.success) return { success: false, response: timeDataResponse.response }

    const reference: Reference = referenceResponse.response;

    const entries: Entries[] = timeDataResponse.response;
    const inUsePC: InUsePC = { value: profitCenterId, label: profitCenterName };
    const details: Details = {
        entries: entries,
        employeeId: employeeId,
        employee: employeeName,
        date: dayjs(date).valueOf(),
        inUsePC: inUsePC
    };

    const props: TimeAdminDetailsProps = {
        details: details,
        reference: reference,
        profitCenter: profitCenterId,
        profitCenterName: profitCenterName
    };

    return { success: true, response: props };
}